export default __webpack_public_path__ + "static/media/6940a20aa86f3fe62cb5cd49c35693ec.svg";